import { motion } from 'framer-motion'
import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import styled, { keyframes } from 'styled-components'
import LogoComponent from '../subComponents/LogoComponent'
import PowerButton from '../subComponents/PowerButton'
import SocialIcons from '../subComponents/SocialIcons'
import { YinYang } from './AllSvgs'
import Intro from './Intro'


const MainContainer = styled(motion.main)`
background: ${props => props.theme.body};
width: 100vw;
height: 100vh;
overflow:hidden;

position: relative;

h2,h3,h4,h5,h6{
  font-family:'Karla', sans-serif ;
  font-weight:500;
}
`

const pageTransition = {
    initial: { opacity: 0, y: 14 },
    animate: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.45, ease: 'easeOut' }
    },
    exit: {
        opacity: 0,
        y: -12,
        transition: { duration: 0.3, ease: 'easeIn' }
    }
}

const Container = styled.div`
padding: 2rem;
`

const Contact = styled.a`
color: ${props => props.theme.text};
@media (max-width: 50em) {
    color: ${props => props.click ? props.theme.body : props.theme.text};
}
position: absolute;
top: 2rem;
right: calc(1rem + 2vw);
text-decoration: none;
z-index:1;
`
const BLOG = styled(NavLink)`
color: ${props => props.click ? props.theme.body : props.theme.text};
position: absolute;
top: 50%;
right: calc(1rem + 2vw);
transform: rotate(90deg) translate(-50%, -50%);
text-decoration: none;
z-index:1;
&.active{
    text-decoration: underline;
    text-underline-offset: 0.35rem;
}
@media (max-width: 50em) {
    display: none;
}
`

const WORK = styled(NavLink)`
color: ${props => props.click ? props.theme.body : props.theme.text};

position: absolute;
top: 50%;
left: calc(1rem + 2vw);
transform: translate(-50%, -50%) rotate(-90deg) ;
text-decoration: none;
z-index:1;
&.active{
    text-decoration: underline;
    text-underline-offset: 0.35rem;
}
@media (max-width: 50em) {
    display: none;
}
`
const RESUME = styled(NavLink)`
color: ${props => props.theme.text};
&.active{
    text-decoration: underline;
    text-underline-offset: 0.35rem;
}
@media (max-width: 50em) {
    display: none;
}
position: absolute;
top: 2rem;
left: calc(10rem + 2vw);
text-decoration: none;
z-index:1;

`

const BottomBar = styled.div`
position: absolute;
bottom: 1rem;
left: 0;
right: 0;
width: 100%;

display: flex;
justify-content: space-evenly;

@media (max-width: 50em) {
    display: none;
}
`

const ABOUT = styled(NavLink)`
color: ${props => props.click ? props.theme.body : props.theme.text};
@media (max-width: 50em) {
    color: ${props => props.click ? props.theme.text : props.theme.text};

}
text-decoration: none;
z-index:1;
&.active{
    text-decoration: underline;
    text-underline-offset: 0.35rem;
}
`
const SKILLS = styled(NavLink)`
color: ${props => props.theme.text};
text-decoration: none;
z-index:1;
&.active{
    text-decoration: underline;
    text-underline-offset: 0.35rem;
}
`

const MobileNav = styled.nav`
display: none;
position: fixed;
bottom: 1rem;
left: 50%;
transform: translateX(-50%);
z-index: 5;
padding: 0.45rem 0.7rem;
border-radius: 999px;
background-color: ${props => props.click ? 'rgba(0,0,0,0.78)' : 'rgba(252,246,244,0.86)'};
backdrop-filter: blur(8px);
gap: 0.3rem;

@media (max-width: 50em) {
    display: flex;
    align-items: center;
}
`

const MobileNavLink = styled(NavLink)`
color: ${props => props.click ? '#FCF6F4' : '#111111'};
text-decoration: none;
font-size: 0.75rem;
font-weight: 700;
letter-spacing: 0.04rem;
padding: 0.35rem 0.55rem;
border-radius: 999px;

&.active{
    background-color: ${props => props.click ? 'rgba(252,246,244,0.2)' : 'rgba(0,0,0,0.14)'};
}
`


const rotate = keyframes`
from{
    transform: rotate(0);
}
to{
    transform: rotate(360deg);
}
`

const Center = styled.button`
position: absolute;
top: ${props => props.click ? '85%' :'50%'  };
left: ${props => props.click ? '92%' :'50%'  };
transform: translate(-50%,-50%);
border: none;
outline: none;
background-color: transparent;
cursor: pointer;

display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
transition: all 1s ease;

&>:first-child{
    animation: ${rotate} infinite 1.5s linear;
}

&>:last-child{
    display: ${props => props.click ? 'none' :'inline-block'  };
    padding-top: 1rem;
    letter-spacing: 0.08rem;
    text-transform: uppercase;
    font-size: 0.82rem;
}

@media (max-width: 50em) {
    top: ${props => props.click ? '72%' :'50%'  };
    left: 50%;
}

@media (prefers-reduced-motion: reduce){
    transition: none;
    &>:first-child{
        animation: none;
    }
}
`

const DarkDiv = styled.div`
position: absolute;
top: 0;
background-color: #000;
bottom: 0;
right: 50%;
width: ${props => props.click ? '50%' : '0%'};
height: ${props => props.click ? '100%' : '0%'};
z-index:1;
transition: height 0.5s ease, width 1s ease 0.5s;

@media (max-width: 50em) {
   /* Set horizontal position to span the full screen */
    left: 0;
    right: unset;
    width: 100%;
    
    /* Remove bottom anchor to allow height to be less than 100% */
    bottom: unset;

    /* Animate height from 0% to 50% */
    height: ${props => props.click ? '50%' : '0%'};

    /* Simplify transition to only animate height */
    transition: height 0.5s ease;
  }
`


const Main = () => {

    const [click, setClick] = useState(false);

    function handleClick(){
        setClick(!click);
        const elem = document.documentElement;
        if (!document.fullscreenElement && elem.requestFullscreen) {
            elem.requestFullscreen().catch(() => {});
        }
    }
    return (
        <MainContainer variants={pageTransition} initial="initial" animate="animate" exit="exit">
         <DarkDiv   click={click}/>
            <Container>
            <PowerButton />
            <LogoComponent theme={click ? 'dark' :'light'}/>
            <SocialIcons  theme={click ? 'dark' :'light'}/>
           
            <Center click={click} onClick={handleClick} aria-label="Toggle intro panel">
                <YinYang width={click ? 120 : 200} height={click ? 120 : 200} fill='currentColor' />
                <span>{click ? 'Opened' : 'click here'}</span>
            </Center>

            <Contact href="mailto:k.sitheswar@gmail.com" click={+click}>
                <motion.h2
                initial={{
                    y:-200,
                    transition: { type:'spring', duration: 1.5, delay:1}
                }}
                animate={{
                    y:0,
                    transition: { type:'spring', duration: 1.5, delay:1}
                }}
                whileHover={{scale: 1.1}}
                whileTap={{scale: 0.9}}
                
                >
                    Say hi..
                </motion.h2>
            </Contact>
            <RESUME to="/resume"  click={+click}>
                <motion.h2
                initial={{
                    y:-200,
                    transition: { type:'spring', duration: 1.5, delay:1}
                }}
                animate={{
                    y:0,
                    transition: { type:'spring', duration: 1.5, delay:1}
                }}
                 whileHover={{scale: 1.1}}
                whileTap={{scale: 0.9}}
                >
                    Resume
                </motion.h2>
            </RESUME>
            <WORK to="/work" click={+click}>
                <motion.h2
                initial={{
                    y:-200,
                    transition: { type:'spring', duration: 1.5, delay:1}
                }}
                animate={{
                    y:0,
                    transition: { type:'spring', duration: 1.5, delay:1}
                }}
                 whileHover={{scale: 1.1}}
                whileTap={{scale: 0.9}}
                >
                    Projects
                </motion.h2>
            </WORK>
            <BLOG to="/blog" click={+click}>
                <motion.h2
                initial={{
                    y:-200,
                    transition: { type:'spring', duration: 1.5, delay:1}
                }}
                animate={{
                    y:0,
                    transition: { type:'spring', duration: 1.5, delay:1}
                }}
                whileHover={{scale: 1.1}}
                whileTap={{scale: 0.9}}
                >
                    Blog
                </motion.h2>
            </BLOG>
            
            <BottomBar>
            <ABOUT to="/about" click={+click}>
                <motion.h2
                initial={{
                    y:200,
                    transition: { type:'spring', duration: 1.5, delay:1}
                }}
                animate={{
                    y:0,
                    transition: { type:'spring', duration: 1.5, delay:1}
                }}
                 whileHover={{scale: 1.1}}
                whileTap={{scale: 0.9}}
                >
                    About
                </motion.h2>
            </ABOUT>
            <SKILLS to="/skills">
                <motion.h2
                initial={{
                    y:200,
                    transition: { type:'spring', duration: 1.5, delay:1}
                }}
                animate={{
                    y:0,
                    transition: { type:'spring', duration: 1.5, delay:1}
                }}
                 whileHover={{scale: 1.1}}
                whileTap={{scale: 0.9}}
                >
                    My Skills
                </motion.h2>
            </SKILLS>
            </BottomBar>

            </Container>
            <MobileNav click={+click} aria-label="Primary mobile navigation">
                <MobileNavLink to="/about" click={+click}>About</MobileNavLink>
                <MobileNavLink to="/skills" click={+click}>Skills</MobileNavLink>
                <MobileNavLink to="/work" click={+click}>Projects</MobileNavLink>
                <MobileNavLink to="/blog" click={+click}>Blog</MobileNavLink>
                <MobileNavLink to="/resume" click={+click}>Resume</MobileNavLink>
            </MobileNav>
            {click ? <Intro click={click} /> : null }
        </MainContainer>
    )
}

export default Main
